export const USERS = 'users';
export const VOCABULARIES = 'vocabularies';
export const PUBLIC = 'public';
